import { Box, Container, Skeleton, Typography } from "@mui/material";
import { getFormattedStatsCount, handleErrorMessage } from "helpers/methods";
import CenteredCardLayout from "layouts/CenteredTableView/CenteredCardLayout";
import { ViewEmailType } from "models/interfaces";
import React, { useEffect, useState } from "react";
import { fetchEmailContent } from "screens/Campaigns/CampaignService";
import parse from "html-react-parser";
import { isEmpty } from "lodash";

interface CustomProps {
  id: number;
  requestedCount?: number;
  containsParentId?: boolean;
}
const ViewEmail = (props: CustomProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [content, setContent] = useState<ViewEmailType>({
    id: 0,
    formEmail: "",
    subject: "",
    content: "",
    groupNames: [],
    tagNames: [],
    groupTagNames: [],
    attachments: {},
  });

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await fetchEmailContent(props.id);
      setContent(response);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      handleErrorMessage(error);
    }
  };

  const getBody = () => {
    return (
      <Box p={2}>
        <Typography>
          <span style={{ fontWeight: 700 }}>From: </span>
          {content.formEmail}
        </Typography>
        <Typography>
          <span style={{ fontWeight: 700 }}>To: </span>
          {props.containsParentId!
            ? `${getFormattedStatsCount(props.requestedCount!)} recipients`
            : content.groupTagNames.join(", ")}
        </Typography>
        <Typography>
          <span style={{ fontWeight: 700 }}>Subject: </span>
          {content.subject}
        </Typography>
        <Typography gutterBottom>
          <span style={{ fontWeight: 700 }}>Attachment: </span>
          {!isEmpty(content.attachments)
            ? Object.keys(content.attachments)
                .map((key) => key)
                .join(", ")
            : "None"}
        </Typography>
        {parse(content.content)}
      </Box>
    );
  };

  return (
    <Container maxWidth="md">
      {loading ? (
        <Skeleton animation="wave" variant="rounded" height={500} />
      ) : (
        <CenteredCardLayout>{getBody()}</CenteredCardLayout>
      )}
    </Container>
  );
};

export default ViewEmail;
